export const isSSR = typeof window === 'undefined'
export const BANDWIDTH_SHARING_RATE = '10'

export const sendDataLayer = (dataLayer: Record<string, unknown>) => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(dataLayer)
}
